import styled, { css } from 'styled-components'

type StyledTypeBadgeProps = {
  $variant?: 'default' | 'success' | 'warning'
}

const typeBadgeVariants = ({ $variant }: StyledTypeBadgeProps) => {
  switch ($variant) {
    case 'success':
      return css<StyledTypeBadgeProps>`
        color: #83be61;
      `
    case 'warning':
      return css<StyledTypeBadgeProps>`
        color: #e18b3b;
      `
    case 'default':
    default:
      return css<StyledTypeBadgeProps>`
        color: inherit;
      `
  }
}

export const TypeBadge = styled.span<StyledTypeBadgeProps>`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 4px;
  width: 52px;
  border: 1px solid;
  border-radius: 5px;
  padding: 3px 8px 3px 6px;
  background-color: #fff;
  font-weight: 600;
  font-size: 0.5rem;
  line-height: 16px;
  ${typeBadgeVariants}

  svg {
    flex: 0 0 auto;
  }
`
